<template>
    <b-form-group :label="$t('people.isUserReadyToNextStage')">
        <div class="d-flex align-items-center">
            <b-form-checkbox
                v-model="ok_user"
                inline
                switch
                @change="$event => toggleModel($event, 'okUser')"
            >
                {{ $t('people.user') }}
            </b-form-checkbox>
            <b-form-checkbox
                v-model="ok_manager"
                inline
                switch
                @change="$event => toggleModel($event, 'okManager')"
            >
                {{ $t('people.manager') }}
            </b-form-checkbox>
        </div>
    </b-form-group>
</template>

<script>
export default {
    name: 'UserReadyNextStage',
    props: {
        okUser: {
            required: false,
            default: false,
        },
        okManager: {
            required: false,
            default: false,
        },
    },
    methods: {
        toggleModel(event, prop) {
            this.$emit('update:' + prop, event)
            this.$emit('change')
        },
    },
    computed: {
        ok_user: {
            get() {
                return this.okUser
            },
            set() {
                //
            },
        },
        ok_manager: {
            get() {
                return this.okManager
            },
            set() {
                //
            },
        },
    },
}
</script>
